import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getPagedDevicesAPI, getSitesOnSchedule, getSiteAnalytics } from "../../Api Methods/Api";
import { Await, useNavigate } from "react-router-dom";
import DevicesList from "../../components/GridList/DevicesList";
import DataManager from "../../hooks/DataManager";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import statClasses from "../../../src/Pages/Dashboard/Dashboard.module.css";
import StatCard from "../../components/UI/Stats/StatCard";
import SearchBar from "../SearchView/Search/SearchBar";
import { filter } from "rxjs";
import ScheduleSitesList from "../SitesOnSchedule/scheduleListSites";
import { Button } from "primereact/button";
import SitesOnScheduleSearchBar from "..//SitesOnSchedule/sitesOnScheduleSearchBar";
import ScheduledActionsList from "./scheduledActionsList";
import { fromUnixTime, set } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import mixpanel from "mixpanel-browser";
import { Dropdown } from "primereact/dropdown";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from "chart.js";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useSetCookie from '../../components/hooks/UseSetCookie';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
        const cfg = chart.config.options.plugins.centerText;
        if (!cfg?.show) return;
        const { ctx, chartArea } = chart;
        const cx = (chartArea.left + chartArea.right) / 2;
        const cy = (chartArea.top + chartArea.bottom) / 2;
        ctx.save();
        ctx.font = `600 16px -apple-system, BlinkMacSystemFont, sans-serif`;
        ctx.fillStyle = "#5c5c5c";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(cfg.text, cx, cy);
        ctx.restore();
    },
};
ChartJS.register(centerTextPlugin);

const C = {
    online: "#60e08f",
    offline: "#ee6d6d",
    fair: "#e8944f",
};

const makeOptions = (centerText) => ({
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
        legend: {
            position: "bottom",
            labels: {
                font: { size: 11 },
                padding: 10,
                boxWidth: 10,
                usePointStyle: true,
                generateLabels: (chart) => {
                    const { labels, datasets } = chart.data;
                    return labels.map((label, i) => ({
                        text: `${label} - ${datasets[0].data[i].toLocaleString()}`,
                        fillStyle: datasets[0].backgroundColor[i],
                        strokeStyle: datasets[0].backgroundColor[i],
                        pointStyle: "circle",
                        hidden: false,
                        index: i,
                    }));
                },
            },
        },
        tooltip: { enabled: true },
        centerText: { show: true, text: centerText },
    },
});

const DonutCard = ({ title, labels, values, colors, centerText }) => {
    const total = values.reduce((a, b) => a + b, 0);
    const data = {
        labels,
        datasets: [{ data: values, backgroundColor: colors, borderWidth: 0, hoverOffset: 4 }],
    };
    const displayText = centerText !== undefined ? centerText : total.toLocaleString();
    return (
        <div className={statClasses.chartCard}>
            <p className={statClasses.chartTitle}>{title}</p>
            <div className={statClasses.donutContainer} style={{ height: "180px"}}>
                <Doughnut data={data} options={makeOptions(displayText)} />
            </div>
        </div>
    );
};

const BarCard = ({ title, labels, datasets }) => {
    const data = { labels, datasets };
    const hasMultipleDatasets = datasets && datasets.length > 1;
    return (
        <div className={statClasses.chartCard}>
            <p className={statClasses.chartTitle}>{title}</p>
            <div className={statClasses.barContainer} style ={{ height: "180px"}}>
                <Bar data={data} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: hasMultipleDatasets }, tooltip: { enabled: true } }, scales: { x: { grid: { display: false } }, y: { beginAtZero: true, ticks: { stepSize: 1 } } } }} />
            </div>
        </div>
    );
};

const SkeletonChart = () => (
    <div className={statClasses.chartCard}>
        <div className={statClasses.skeletonBar} style={{ height: "14px", width: "55%", marginBottom: "16px" }} />
        <div className={statClasses.skeletonCircle} />
        <div className={statClasses.skeletonBar} style={{ height: "10px", width: "80%", marginTop: "14px" }} />
    </div>
);

const SkeletonBarChart = () => (
    <div className={statClasses.chartCard}>
        <div className={statClasses.skeletonBar} style={{ height: "14px", width: "40%", marginBottom: "16px" }} />
        <div className={statClasses.skeletonBar} style={{ height: "170px", width: "100%" }} />
    </div>
);

const GsSkeletonMainTableCard = () => (
    <div className={statClasses.chartCard}>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
    </div>
);

const ScheduledActionsSites = () => {

  const dataManager = new DataManager();
     
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const companyName = useSelector(state => state.auth.companyName);
  const role = useSelector(state => state.auth.role);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const prevBody = useRef();
  const apiDataRef = useRef({ token, client, companyName });
  apiDataRef.current = { token, client, companyName };
  const apiData = {
      token,
      client
  }
 
  const [groups, setGroups] = useState([])
  const pageSize = 100;

  const cachedSites = useSelector(state => state.service.ScheduleSitesTableData);
  const [sites, setSites] = useState(cachedSites);
  const [visibleDevices, setVisibleDevices] = useState(
    cachedSites.slice(0, pageSize)
  );
  const [isLoading, setIsLoading] = useState(() => {
    return !cachedSites || cachedSites.length === 0;
  }); 
  const [isLoadingStats, setIsLoadingStats] = useState(true)
  const [filteredSites, setFilteredSites] = useState([]);
  
  const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
  const [selectedFilter, setSelectedFilter] = useState("")
  const [daysFilter, setDaysFilter] = useState([])
  const [sortBy, setSortBy] = useState([])
  const [page, setPage] = useState(1);
  const [wHm, setWHm] = useState(false)
  const [woHm, setWoHm] = useState(false)
  const [excludeLocks, setExcludeLocks] = useState(false)
  const [excludePulse, setExcludePulse] = useState(false)
  const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
  const [includes, setIncludes] = useState(true)
  const [refresh, setRefresh] = useState(0)
  const [sitesWithHolidayMode, setSitesWithHolidayMode] = useState("")
  const [fuzzySearch, setFuzzySearch] = useState(-1)
  const [siteLocation, setSiteLocation] = useState(null)
  const [siteType, setSiteType] = useState(null)
  const [CCTVType, setCCTVType] = useState(null)
  const [scheduleStats, setScheduleStats] = useState(null);
  const [scheduleSuccesses, setScheduleSuccesses] = useState(null);
  const [sitesAffected, setSitesAffected] = useState(null);
  const [isLoadingScheduleStats, setIsLoadingScheduleStats] = useState(true);
  const [isLoadingStatCards, setIsLoadingStatCards] = useState(true);
  const [selectedIntegration, setSelectedIntegration] = useState("");
  const [selectedTime, setSelectedTime] = useState("7D");
  const [activeTab, setActiveTab] = useState(0);
  const scheduleRequestId = useRef(0);

  const times = ["7D", "1M", "3M"];

  const now = new Date();    
  const last7 = new Date();
  last7.setDate(now.getDate() - 7);
  const last30 = new Date();
  last30.setDate(now.getDate() - 30);
  const last90 = new Date();
  last90.setDate(now.getDate() - 90);
  
  const dayToIndex = {
    Mondays: "0",
    Tuesdays: "1",
    Wednesdays: "2",
    Thursdays: "3",
    Fridays: "4",
    Saturdays: "5",
    Sundays: "6",
  };
  

  const HandleLoadMore = () => {
    const nextPage = page + 1;
    const start = page * pageSize;
    const end = nextPage * pageSize;
    const nextDevices = filteredSites.slice(start, end);

    if (nextDevices.length > 0) {
      setVisibleDevices(prev => [...prev, ...nextDevices]);
      
      setPage(nextPage);
    }
  };

  useEffect(() => {
    //setIsLoading(true)
    const getSites = async () => {
      const responseData = await getSitesOnSchedule(apiData, 0, dispatch)
      const raw = responseData.data[0]
      const parsed = raw.map(site => {
        let parsedDeviceDetails = {};
        let parsedDeviceExtraDetails = {};
        let parsedScheduledActions = {};

        try {
          parsedDeviceDetails = JSON.parse(site.deviceDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceDetails for site ID ${site.id}`, e);
        }

        try {
          parsedDeviceExtraDetails = JSON.parse(site.deviceExtraDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceExtraDetails for site ID ${site.id}`, e);
        }

        try {
          parsedScheduledActions = JSON.parse(site.scheduledActions || '{}');
        } catch (e) {
          console.warn(`Failed to parse scheduledActions for site ID ${site.id}`, e);
        }
        
        return {
          ...site,
          parsedDeviceDetails,
          parsedDeviceExtraDetails,
          parsedScheduledActions
        };
      });

      setSites(parsed);
      //dispatch
      dispatch(serviceActions.setScheduleSitesTableData(parsed));
      setIsLoading(false)
      setIsLoadingStats(false)
    };

    const GetGroups = async () => {
      try {
        const listOptions = await getGroups(apiData, dispatch);
        const groupNames = listOptions.map(group => group.name).sort((a, b) => a.localeCompare(b));
        setGroups(groupNames || []);
      } catch (error) {
        setGroups([]);
      }
    };

    getSites();
    GetGroups();

    mixpanel.track("Scheduled sites tab visited", {
      user: localStorage.getItem('email')
    });
    // getSitesWithHolidayMode();
  }, [refresh]);

  useEffect(() => {
        const currentRequestId = ++scheduleRequestId.current;
        setScheduleStats([]);
        setIsLoadingScheduleStats(true);
        setIsLoadingStatCards(true);
        const FetchScheduleStats = async () => {
            const response = await getSiteAnalytics(apiDataRef.current, {
                siteUUID: "",
                groupName: apiDataRef.current.companyName || localStorage.getItem('companyName'),
                integration_type: selectedIntegration == "All" ? "" : selectedIntegration?.toUpperCase() || "" ,
                start_date: selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90,
                analyticsType: "schedules"
            }, dispatch);
            if (currentRequestId !== scheduleRequestId.current) return;
            setScheduleStats(response.data[0].failures || []);
            setScheduleSuccesses(response.data[0].totalSuccess?.total_success || 0);
            const sitesWithIds = (response.data[0].sitesAffected || []).map((site, index) => ({
                ...site,
                rowId: `${site.siteID}-${site.pin}-${site.subType}-${index}`
            }));
            setSitesAffected(sitesWithIds);
            setIsLoadingScheduleStats(false);
            setIsLoadingStatCards(false);
        };
        //FetchScheduleStats();
    }, [selectedTime, selectedIntegration]); 

  useEffect(() => {
    if (!sites || sites.length === 0) return;
    let filtered;

    if (wHm) {
      filtered = [...sitesWithHolidayMode];
    } else if (woHm) {
      const holidayUuids = new Set(sitesWithHolidayMode.map(site => site.uuid));
      filtered = sites.filter(site => !holidayUuids.has(site.uuid));
    } else {
      filtered = [...sites];
    }

    if (selectedGroupFilter.length > 0) {
      filtered = filtered.filter(site => selectedGroupFilter.includes(site.name));
    }

    if (selectedFilter.length > 0) {
      if (selectedFilter.includes("Online")) {
        filtered = filtered.filter(site => site.online === "YES");
      }

      if (selectedFilter.includes("Offline")) {
        filtered = filtered.filter(site => site.online === "NO");
      }

      if (selectedFilter.includes("No portal site name")) {
        filtered = filtered.filter(site => site.tag == "");
        
      }

      if (selectedFilter.includes("Only active sites")) {
        filtered = filtered.filter(site => site.active == 1);
      }

      if (selectedFilter.includes("Only inactive sites")) {
        filtered = filtered.filter(site => site.active == 0);
      }
    }

    if (daysFilter.length > 0) {
      filtered = applyDayFilter(filtered, daysFilter, fuzzySearch);
    }

    if (searchTerm !== "" && (searchTerm !== dataManager.getItem('scheduleSitesSearchTerm'))){
      filtered = filtered.filter((item) =>
        Object.values(item)
          .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      dataManager.setItem('scheduleSitesSearchTerm', searchTerm)
    }

    if (portalSiteNameFilter !== ""){
      if (includes) {
        filtered = filtered.filter(item =>
          item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      } else {
        filtered = filtered.filter(item =>
          !item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      }
    }

    if (sortBy.length > 0) {
      const outputPinIds = {
        "Output 1 active": "5",
        "Output 2 active": "6",
        "Output 3 active": "13",
        "Output 4 active": "19",
      };

      const outputPinValues = Object.values(outputPinIds);

      if (sortBy.includes("Single pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount === 1;
        });
      }

      if (sortBy.includes("Multi pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount > 1;
        });
      }

      const outputFilters = sortBy.filter(item => outputPinIds[item]);
      const selectedPinIds = outputFilters.map(label => outputPinIds[label]);

      if (selectedPinIds.length > 0) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          return outputPinValues.every(pinId => {
            const pin = details[pinId];
            const shouldBeActive = selectedPinIds.includes(pinId);
            return shouldBeActive
              ? pin?.active === 1
              : !pin || pin.active !== 1;
          });
        });
      }
    }

    if (excludePulse) {
      filtered = filtered.filter(site => {
        const details = site.parsedDeviceDetails;

        for (const pinId in details) {
          const pin = details[pinId];
          if (pin?.type === "PULSE" || pin?.type === "VIRTUAL_PULSE") {
            return false; // Exclude this site
          }
        }

        return true;
      });
    }

     if (siteLocation != null){
        filtered = filtered.filter(item =>
          item?.country_code?.includes(siteLocation.code)
        );
      }

      if (CCTVType != null){
        if (CCTVType == "Ganz Aibox"){
          setCCTVType("AIBOX")
        }
        console.log(CCTVType);
        console.log(filtered);
            filtered = filtered.filter(item =>
              item?.integrationType?.includes(CCTVType.toUpperCase())
            );
      }

      if (siteType != null){
        filtered = filtered.filter(item =>
          item?.site_type?.includes(siteType.label)
        );
      }

    setFilteredSites(filtered);
    setVisibleDevices(filtered.slice(0, pageSize));
    setPage(1);

    let mixPanelBody = {
      selectedGroupFilter: selectedGroupFilter,
      selectedFilter: selectedFilter,
      sortBy: sortBy,
      wHm: wHm,
      woHm: woHm,
      excludeLocks: excludeLocks,
      excludePulse: excludePulse,
      portalSiteNameFilter: portalSiteNameFilter,
      includes: includes,
      daysFilter: daysFilter,
      fuzzySearch: fuzzySearch,
      "searchTerm": searchTerm
    }

    const timer = setTimeout(() => {
    if (prevBody.current && (JSON.stringify(mixPanelBody) !== JSON.stringify(prevBody.current))) {
      mixpanel.track("Scheduled sites search performed", {
          user: localStorage.getItem('email'),
          body: mixPanelBody
        });
      }
      prevBody.current = mixPanelBody
    }, 2000);
    return () => clearTimeout(timer);
  }, [sites, selectedGroupFilter, selectedFilter, searchTerm, sortBy, wHm, woHm, excludeLocks, excludePulse, portalSiteNameFilter, includes, daysFilter, fuzzySearch, siteType, siteLocation, CCTVType]);


  function applyDayFilter(devices, daysFilter, fuzzySearch) {
    const dayIndexes = daysFilter.map(day => dayToIndex[day]);
  
    return devices
      .filter(site =>
        site.parsedScheduledActions?.some(schedule => {
          return dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          );
        })
      )
      .map(site => {
        const matchingSchedules = site.parsedScheduledActions.filter(schedule =>
          dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          )
        );
  
        return {
          ...site,
          parsedScheduledActions: matchingSchedules,
        };
      });
  }

  const getScheduleStats = () => {
        if ((!scheduleStats || scheduleStats.length === 0) && (!scheduleSuccesses || scheduleSuccesses === 0)) return { total: 0, totalFails: 0, successRate: 0, totalSuccess: 0, totalArmFails: 0, totalDisarmFails: 0, data: [] };

        const dataSource = scheduleStats;

        const totalFails = dataSource.reduce((total, item) => total + item.disarmed_fail + item.armed_fail, 0);
        const totalSuccess = scheduleSuccesses;
        const total = totalFails + totalSuccess;
        const totalArmFails = dataSource.reduce((total, item) => total + item.armed_fail, 0);
        const totalDisarmFails = dataSource.reduce((total, item) => total + item.disarmed_fail, 0);
        const successRate = total === 0 ? 0 : (totalSuccess / total * 100).toFixed(1);


        return { total, totalFails, successRate, totalSuccess, totalArmFails, totalDisarmFails, data: dataSource };
    }

  
  const HandleHolidayModeStatClick = () => {
    setWHm(true)
    setWoHm(false)
  }

  const HandleTotalSitesStatClick = () => {
    setSelectedFilter("")
    setSortBy([])
    setSelectedGroupFilter([])
    setWHm(false)
    setWoHm(false)
    setExcludeLocks(false)
    setExcludePulse(false)
  }

  // for 3 months - schedules
  const processedScheduleData = useMemo(() => {
  if (selectedTime !== "3M") return scheduleStats;

  const map = {};

  scheduleStats.forEach(item => {
      const date = new Date(item.event_date);
      const key = date.getMonth();

      if (!map[key]) {
          map[key] = { ...item };
      } else {
          map[key].armed_fail += item.armed_fail;
          map[key].disarmed_fail += item.disarmed_fail;
      }
  });

  return Object.values(map);
  }, [scheduleStats, selectedTime]);

  const formatEventDate = (dateStr, period) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        

        switch (period) {
        case '7D':
            return date.toLocaleDateString('en-US', { weekday: 'short' });
        case '1M':
            return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        case '3M':
            return date.toLocaleDateString('en-US', { month: 'short' });
        case 'standard':
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        default:
            return dateStr;
        }
    };

    const formatPin = (pin) => {
      switch (pin) {
        case 5:
          return "Pin 1";
        case 6:
          return "Pin 2";
        case 13:
          return "Pin 3";
        case 19:
          return "Pin 4";
        case 25:
          return "Pin 5";
        case 26:
          return "Pin 6";
        case 27:
          return "Pin 7";
        case 28:
          return "Pin 8";
        default:
          return pin;
      }
    };

    const HandleUipiodOnClick = (DeviceUUID) => {
      dispatch(serviceActions.setDeviceUUID(DeviceUUID));
      useSetCookie("DeviceUUID", DeviceUUID, 1);
      navigate("/Dashboard/SiteView/" + DeviceUUID);
    }

    
  return (
    <Await resolve={visibleDevices}>
      {(loadedSites) => {
        return (
          <>
            <div style={{ width: "100%"}}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 290px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
                <StatCard title={"Scheduled sites"} value={sites.length} isLoading={isLoadingStats} onClick={HandleTotalSitesStatClick} />
                {/* <StatCard title={"Schedule events"} value={getScheduleStats().total} isLoading={isLoadingStatCards} />
                <StatCard title={"Successful triggers"} value={getScheduleStats().totalSuccess} isLoading={isLoadingStatCards} />
                <StatCard title={"Failed triggers"} value={getScheduleStats().totalFails} isLoading={isLoadingStatCards} />
                <StatCard title={"Success rate"} value={`${getScheduleStats().successRate}%`} isLoading={isLoadingStatCards} /> */}
              </div>

              <br></br>

              <div className={classes.tabsWrapper}>
                  <div className={classes.tabs}>
                    {/* ..(role === "admin" || role === "TechSupport" ? ["Analytics"] : []) */}
                      {["Scheduled sites"].map((tab, i) => (
                          <button
                              key={tab}
                              className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                              onClick={() => setActiveTab(i)}
                          >
                              {tab}
                          </button>
                      ))}
                  </div>

                  <div className={classes.tabContent}>
                      {activeTab === 0 && (
                          isLoading ? (
                              <div style={{ display: "flex", width: "100%" }}>
                                  <DeviceLoadingGrid CardCount={20} />
                              </div>
                          ) : (
                              <>
                                  <div className={classes.searchContainer}>
                                      <SitesOnScheduleSearchBar
                                          type="text"
                                          placeholder="Search..."
                                          value={searchTerm}
                                          onChange={(e) => setSearchTerm(e.target.value)}
                                          showFilterButton={true}
                                          groups={groups}
                                          selectedGroupFilter={selectedGroupFilter}
                                          setSelectedGroupFilter={setSelectedGroupFilter}
                                          selectedFilter={selectedFilter}
                                          setSelectedFilter={setSelectedFilter}
                                          sortBy={sortBy}
                                          setSortBy={setSortBy}
                                          wHm={wHm}
                                          setWHm={setWHm}
                                          woHm={woHm}
                                          setWoHm={setWoHm}
                                          excludeLocks={excludeLocks}
                                          setExcludeLocks={setExcludeLocks}
                                          excludePulse={excludePulse}
                                          setExcludePulse={setExcludePulse}
                                          portalSiteNameFilter={portalSiteNameFilter}
                                          setPortalSiteNameFilter={setPortalSiteNameFilter}
                                          includes={includes}
                                          setIncludes={setIncludes}
                                          isSchedules={true}
                                          daysFilter={daysFilter}
                                          setDaysFilter={setDaysFilter}
                                          fuzzySearch={fuzzySearch}
                                          setFuzzySearch={setFuzzySearch}
                                          siteLocation={siteLocation}
                                          setSiteLocation={setSiteLocation}
                                          siteType={siteType}
                                          setSiteType={setSiteType}
                                          CCTVType={CCTVType}
                                          setCCTVType={setCCTVType}
                                          style={{
                                              padding: "10px",
                                              width: "300px",
                                              fontSize: "14px",
                                              boxSizing: "border-box",
                                              borderRadius: "4px",
                                          }}
                                      />
                                      <div>
                                          <p>{filteredSites.length} results</p>
                                      </div>
                                  </div>

                                  <ScheduledActionsList
                                      devices={loadedSites}
                                      refresh={refresh}
                                      setRefresh={setRefresh}
                                  />

                                  <div style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'center',
                                      marginTop: "15px"
                                  }}>
                                      <Button icon="pi pi-plus" style={{ width: "30%" }} label="Load more" onClick={HandleLoadMore} />
                                  </div>
                              </>
                          )
                      )}

                      {activeTab === 1 && (
                        <>

                        <div style={{display: "flex",justifyContent: "space-between", alignItems: "center"}}>
                            <div className={statClasses.timeButtons} style={{marginBottom: "10px"}}>
                                  {times.map((time) => (
                                      <button
                                          key={time}
                                          className={selectedTime === time ? statClasses.timeButtonActive : statClasses.timeButton}
                                          onClick={() => setSelectedTime(time)}
                                      >
                                          {time}
                                      </button>
                                  ))}
                            </div>
                            <div className={statClasses.timeDropdown} style={{marginBottom: "10px"}}>
                              <Dropdown
                                  value={selectedIntegration}
                                  options={["All", "Ajax", "Dahua", "Hikvision", "AIBOX"]}
                                  placeholder="Filter by integration"
                                  onChange={(e) => setSelectedIntegration(e.value)}
                                  className={statClasses.dropdown}
                                  style={{width: "220px"}}
                              />
                            </div>
                          </div>
                          <div className={statClasses.chartsRow} style={{ marginTop: "14px" }}>
                            {isLoadingScheduleStats ? (
                              <>
                                <div className={statClasses.donutWrapper}>
                                  <SkeletonChart />
                                </div>
                                <div className={statClasses.barWrapper}>
                                  <SkeletonBarChart />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className={statClasses.donutWrapper}>
                                    {getScheduleStats().total === 0 ? (
                                        <div className={statClasses.chartCard}>
                                            <p className={statClasses.chartTitle}>Schedule success rate</p>
                                            <div style={{ height: "180px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <p style={{ textAlign: "center", color: "#888888", margin: 0 }}>
                                                    No data for this period.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <DonutCard
                                            title="Schedule success rate"
                                            labels={["Success", "Arm failed", "Disarm failed"]}
                                            values={[getScheduleStats().totalSuccess, getScheduleStats().totalArmFails, getScheduleStats().totalDisarmFails]}
                                            colors={[C.online, C.offline, C.fair]}
                                            centerText={`${getScheduleStats().successRate}%`}
                                        />
                                    )}
                                </div>

                                <div className={statClasses.barWrapper}>
                                    {getScheduleStats().totalFails === 0 ? (
                                        <div className={statClasses.chartCard}>
                                            <p className={statClasses.chartTitle}>Failed schedules over time</p>
                                            <div style={{ height: "180px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <p style={{ textAlign: "center", color: "#888888", margin: 0 }}>
                                                    No failed schedules for this period.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <BarCard
                                            title="Failed schedules over time"
                                            labels={processedScheduleData.map(item => formatEventDate(item.event_date, selectedTime))}
                                            datasets={[
                                                {
                                                    label: "Failed Arm Schedules",
                                                    data: processedScheduleData.map(item => item.armed_fail),
                                                    backgroundColor: C.offline,
                                                },
                                                {
                                                    label: "Failed Disarm Schedules",
                                                    data: processedScheduleData.map(item => item.disarmed_fail),
                                                    backgroundColor: C.fair,
                                                }
                                            ]}
                                        />
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                          <br />
                          {isLoadingScheduleStats ? (
                            <GsSkeletonMainTableCard />
                          ) : (
                            <>
                            <div className={statClasses.chartCard}>
                              <p className={statClasses.chartTitle}>Sites to Review</p>
                              <DataTable value={sitesAffected} showGridlines={true} rows={20} removableSort dataKey="rowId" emptyMessage="No site failures" >
                                <Column
                                  field="siteKey"
                                  header="Site ID"
                                  style={{ minWidth: "8rem" }}
                                  body={(rowData) => (
                                      <span
                                          className={classes.tableUser}
                                          onClick={() => {HandleUipiodOnClick(rowData.siteID)}}>
                                          {rowData.siteKey}
                                      </span>
                                  )}
                                />
                                <Column field="siteName" header="Name" style={{ minWidth: "12rem" }} />
                                <Column field="pin" header="Output" style={{ minWidth: "6rem" }} body={(rowData) => formatPin(rowData.pin)} />
                                <Column field="subType" header="Type" style={{ minWidth: "8rem" }} />
                                <Column field="total_failures" header="Total failures" sortable style={{ minWidth: "8rem" }} />
                                <Column field="latest_failure" header="Latest failure" sortable style={{ minWidth: "12rem" }} body={(rowData) => formatEventDate(rowData.latest_failure, "standard")} />
                              </DataTable>
                              </div>
                            </>
                          )}
                      </>
                      )}
                  </div>
              </div>
            </div>
            
          </>
          
        )
      }}
    </Await>
  )
}

export default ScheduledActionsSites;